module.exports = __webpack_public_path__ + "static/img/far2_active.d3590d15.png";